export default __webpack_public_path__ + "static/media/kotlin.bf3c189f.svg";